var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.038 3.924c0-1.13.926-2.057 2.057-2.057 1.131 0 2.057.926 2.057 2.057 0 1.13-.926 2.057-2.057 2.057-.49 0-.935-.181-1.29-.47L5.978 7.934c.052.179.089.365.089.56 0 .156-.02.306-.054.452l3.926 2.154a2.042 2.042 0 011.385-.549c1.13 0 2.057.927 2.057 2.058 0 1.13-.927 2.057-2.057 2.057a2.064 2.064 0 01-2.057-2.057c0-.267.055-.52.148-.754L5.61 9.769a2.048 2.048 0 01-1.6.783 2.064 2.064 0 01-2.058-2.057c0-1.13.927-2.057 2.058-2.057.606 0 1.149.272 1.526.694l3.7-2.344a2.027 2.027 0 01-.198-.864z",
    fill: "#A4A4A4"
  })));
}

export default SvgShareIcon;